export class TravelBankProfile {
    constructor()
    {
        this.MembershipNumber=null;
        this.Password=null;
    }
}